import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';

import oculaLogo from '@src/assets/ocula-light-logo-green.svg';
import { focusRing } from '@src/theme/mixins';

export interface SiteLogoProps {
  /** If the component should render the full or compact UI. */
  compact: boolean;
  /** The path that clicking on the Ocula logo links to. */
  homePath: string;
}

const StyledLink = styled(Link)<{ $compact: boolean }>`
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-image: url(${oculaLogo});
  background-size: cover;
  align-self: center;
  /* filter: contrast(200%) saturate(300%) ; */
  ${({ $compact }) =>
    !$compact &&
    css`
      width: 120px;
    `}
  ${focusRing};
`;

export function SiteLogo({ homePath, compact }: SiteLogoProps) {
  return <StyledLink $compact={compact} to={homePath} aria-label="Ocula - Home page" />;
}
